"use client";

import type { InputHTMLAttributes } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FilledInput from "@mui/material/FilledInput";
import { SearchOutlinedIcon } from "./styles";
import useSearch from "./use-search";
import SearchResult from "../search-result";

const SearchInput = ({ searchCallback }: { searchCallback?: () => void }) => {
  const {
    query,
    containerRef,
    handleSearchByUrlParam,
    handleSearch,
    resultList,
    isSearchLoading,
    searchInputProps,
  } = useSearch();

  const onSubmitSearch = () => {
    handleSearchByUrlParam();
    searchCallback?.();
  };

  return (
    <Box ref={containerRef} position="relative" flex="1 1 0" width="100%" maxWidth="540px">
      <FilledInput
        fullWidth
        hiddenLabel
        placeholder="Bạn đang cần tìm kiếm gì?"
        disableUnderline
        value={query}
        onChange={handleSearch}
        inputProps={searchInputProps as InputHTMLAttributes<HTMLInputElement>}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            onSubmitSearch();
          }
        }}
        sx={{ borderRadius: "8px" }}
        endAdornment={
          <Button
            type="button"
            variant="contained"
            color="primary"
            onClick={onSubmitSearch}
            sx={{ p: "4px 8px", borderRadius: "8px" }}
          >
            <SearchOutlinedIcon sx={(theme) => ({ color: theme.palette.common.white, m: 0 })} />
          </Button>
        }
      />
      {resultList.length > 0 || isSearchLoading ? (
        <SearchResult results={resultList} isLoading={isSearchLoading} />
      ) : null}
    </Box>
  );
};

export default SearchInput;
